module.exports = "<!-- buscador general -->\n<!-- <input #search class=\"form-control\" type=\"text\" placeholder=\"Search...\" (keydown.enter)=\"onSearch(search.value)\"> -->\n<!-- tabla -->\n<ng2-smart-table \n    [settings]=\"settings\" \n    [source]=\"source\" \n    (userRowSelect)=\"rowSelect($event)\" \n    (create)=\"accion($event)\"\n    (edit)=\"accion($event)\"\n    (delete)=\"accion($event)\">\n</ng2-smart-table>"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/data-table/data-table.component.html
// module id = ./src/app/examples/data-table/data-table.component.html
// module chunks = main